import { z } from 'zod';

/**
 * URL search params of the admin logs pages (global and per tenant), so filters,
 * tab and page survive reloads and can be shared as links.
 */
export const adminLogsSearchSchema = z.object({
  tab: z.enum(['executions', 'audit']).catch('executions'),
  period: z.enum(['today', '7d', '30d', 'custom']).catch('7d'),
  from: z.string().optional(),
  to: z.string().optional(),
  status: z.enum(['STARTED', 'COMPLETED', 'FAILED']).optional(),
  /** Tenant filter on the global page */
  clientId: z.string().optional(),
  /** Audit scope on the tenant page: the tenant ID or one of its company IDs */
  auditScope: z.string().optional(),
  search: z.string().optional(),
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce.number().int().min(1).max(100).catch(20)
});

export type AdminLogsSearch = z.infer<typeof adminLogsSearchSchema>;
